import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Leaf, XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import "../styles/emergence.css";

export default function EmergencePaymentCancel() {
  const { i18n } = useTranslation();
  const isFrench = i18n.language === 'fr';

  return (
    <div className="emergence-bg min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="emergence-card bg-white p-10 rounded-3xl">
          <div className="w-20 h-20 rounded-full bg-[#7A8B99]/10 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-[#7A8B99]" />
          </div>

          <h1 className="font-heading text-2xl font-bold text-[#2D5A66] mb-3">
            {isFrench ? "Paiement annulé" : "Payment cancelled"}
          </h1>

          <p className="text-[#7A8B99] mb-8">
            {isFrench 
              ? "Pas de souci, tu peux revenir quand tu veux. Les parcours gratuits restent disponibles."
              : "No worries, you can come back anytime. Free journeys remain available."}
          </p>

          <div className="space-y-3">
            <Link to="/emergence/parcours" className="block">
              <Button className="w-full emergence-btn-primary">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {isFrench ? "Retour aux parcours" : "Back to journeys"}
              </Button>
            </Link>
            <Link to="/emergence" className="block">
              <Button variant="outline" className="w-full rounded-full border-[#3B7A8C]/20 text-[#7A8B99]">
                {isFrench ? "Retour à l'accueil" : "Back to home"}
              </Button>
            </Link>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-8">
          <Leaf className="w-5 h-5 text-[#3B7A8C]" />
          <span className="font-heading text-[#2D5A66]">Épanoui</span>
        </div>
      </div>
    </div>
  );
}
